import { render, staticRenderFns } from "./index.vue?vue&type=template&id=584aa30b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584aa30b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584aa30b')) {
      api.createRecord('584aa30b', component.options)
    } else {
      api.reload('584aa30b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=584aa30b&scoped=true", function () {
      api.rerender('584aa30b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/globalModals/index.vue"
export default component.exports